import { generateClient } from "aws-amplify/api";
import { createAddress, updateAddress, deleteAddress as removeAddress } from "graphql/customs/mutations";
import { addressByDate, getAddress as fetchAddress } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";

const API = generateClient();

export const saveAddress = async (data) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updateAddress : createAddress;
    let cleanData = cleanUpData(data);

    delete cleanData["poBox"];
    cleanData["type"] = "Address";

    const addressResponse = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData
        }
    });

    return getDataFromResponse(addressResponse, operationName === "create" ? "createAddress" : "updateAddress");
};

export const getAddresses = async (filter = {}) => {
    const data = await API.graphql({
        query: addressByDate,
        variables: {
            "filter": filter,
            "type": "Address",
            "sortDirection": "DESC"
        }
    })
    return getNotDeletedItems(data, "addressByDate");
}

export const getAddress = async (addressId) => {
    let addressObject = await API.graphql({
        query: fetchAddress,
        variables: {
            id: addressId
        }
    });
    return getDataFromResponse(addressObject, "getAddress");
}

export const deleteAddress = async (addressData) => {
    const deletedAsset = await API.graphql({
        query: removeAddress,
        variables: {
            input: {
                "id": addressData.id,
            }
        }
    });
    return getDataFromResponse(deletedAsset, "deleteAddress");
}